export default __webpack_public_path__ + "static/media/spotbg.f2d8692e.png";